import { type RouteComponentProps, useLocation } from "react-router";

import type { SystemFilterType } from "@btnet/services-btnet/handlers/models/systemFilterType";

import { parseParams } from "utilities/url/url";

export function getSystemFilter({
    location,
}: Pick<RouteComponentProps, "location">): SystemFilterType | undefined {
    const params = parseParams<{
        filter: SystemFilterType;
    }>(location.search);
    return params.filter ?? undefined;
}

export function useSystemFilter(): SystemFilterType | undefined {
    const location = useLocation();
    return getSystemFilter({ location });
}
